<app-about-the-fold id="aboutTheFold"></app-about-the-fold>
<app-about-me id="aboutMe"></app-about-me>
<app-my-skills id="mySkills"></app-my-skills>
<app-projects id="projects"></app-projects>
<app-thoughts></app-thoughts>
<app-contact id="contact"></app-contact>